import { profileService } from "../../api/profileService/profileService";
import { fleetService } from "../../api/fleetService/fleetServicesRegistered";
import { IsAuthorized } from "../../utils/helpers/auth";

export const flattenVehicles = (data: any) => {
    const vehicles: any[] = [];
    const fleet: any = data.fleet;
  
    Object.keys(fleet).forEach((mainCategoryKey) => {
      const mainCategory = fleet[mainCategoryKey];
  
      Object.keys(mainCategory).forEach((subCategoryKey) => {
        const items = mainCategory[subCategoryKey];
  
        items.forEach((vehicle: any) => {
          vehicles.push({
            ...vehicle,
            category: subCategoryKey, // Sottocategoria
            mainCategory: mainCategoryKey, // ✅ Corretto: ora è una stringa, non un oggetto
          });
        });
      });
    });
  
    return vehicles;
  };

export const getFleetData = async () => {
    if (IsAuthorized()) {
        // Controllo condizionale: NON chiamare getProfile su FleetAndRoute
        let profileApi = null;
        let businessProfile = null;
        
        if (window.location.pathname.startsWith("/fleet-and-route")) {
            // Su FleetAndRoute, controlla se i dati del profilo sono già in sessionStorage
            const storedProfile = sessionStorage.getItem("profile");
            if (storedProfile) {
                profileApi = JSON.parse(storedProfile);
            }
            // Fai comunque la chiamata a getBusinessProfile
            const businessProfileRes = await profileService.getBusinessProfile();
            if (businessProfileRes.success) {
                businessProfile = businessProfileRes.responseBody;
            }
        } else {
            // Per tutte le altre pagine, comportamento normale
            const profileRes = await profileService.getProfile();
            const businessProfileRes = await profileService.getBusinessProfile();
            
            if (profileRes.success && businessProfileRes.success) {
                profileApi = profileRes.responseBody;
                businessProfile = businessProfileRes.responseBody;
            }
        }

        if (businessProfile) {
            try {
                const driversRes = await fleetService.getDriversBySupplierCode(
                    businessProfile.legacycodes[0].legacycode,
                    businessProfile.legacycodes[0].company
                );

                const vehiclesRes = await fleetService.getFleetInfoBySupplier(
                    businessProfile.legacycodes[0].legacycode,
                    businessProfile.legacycodes[0].company
                )

                const fleetInfoRes = await fleetService.getFleetInfoTypes();

                return {
                    profileApi: profileApi,
                    businessProfileApi: businessProfile,
                    drivers: driversRes ? driversRes : [],
                    fleetInfo: fleetInfoRes || { types: {}, envclasses: [], fuels: [] },
                    vehiclesList: vehiclesRes ? flattenVehicles(vehiclesRes) : [],
                };
            } catch (error) {
                console.error("Errore nel recupero degli autisti:", error);
                return {
                    profileApi: profileApi,
                    businessProfileApi: businessProfile,
                    drivers: [],
                    fleetInfo: { types: {}, envclasses: [], fuels: [] },
                    vehiclesList: {},
                };
            }
        } else {
            console.log('Errore nel recupero dei dati business profile');
        }
    } 
    
    return {
        profileApi: null,
        businessProfileApi: null,
        drivers: [],
        fleetInfo: { types: {}, envclasses: [], fuels: [] },
        vehiclesList: {},
    };
};
